export default {
  "notifications": {
    "broken_favorite": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estatut desconegut, sèm a lo cercar..."])},
    "favorited_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["a aimat vòstre estatut"])},
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vos a seguit"])},
    "load_older": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cargar las notificacions mai ancianas"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notficacions"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legit !"])},
    "repeated_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["a repetit vòstre estatut"])},
    "no_more_notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas mai de notificacions"])}
  }
}